module.exports = __webpack_public_path__ + "static/img/fish45.3dbfa3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish45.png
// module id = xYNR
// module chunks = 0